module.exports = __webpack_public_path__ + "img/industries-1.ea3a1034.png";